import useCopyUrlToClipboard from '@/pages/CompanyReport/hooks/useCopyUrlToClipboard';
import CopyLink from '@assets/images/narrative/copy-link.svg';
export const ShareNarrative = () => {
  const copyUrlToClipboard = useCopyUrlToClipboard();

  return (
    <div
      onClick={copyUrlToClipboard}
      className="flex cursor-pointer items-center gap-2"
      role="button"
    >
      <div className="flex items-center gap-1">
        <div className="flex items-center">
          <CopyLink
            aria-label="Share"
            className="size-4 stroke-softer lg:size-5"
          />
        </div>
        <span className="text-tiny text-solid">Share</span>
      </div>
    </div>
  );
};
